// Garante que todo usuário tenha a experiência da versão nova:
// - resetStorageIfOutdated(): no boot, se a versão de storage mudou, zera o localStorage
//   e mata SW/cache legado.
// - watchForNewBuild(): detecta um build novo publicado (via /version.json) e recarrega
//   a aba, inclusive as que já estavam abertas.

// Bump MANUAL: só quando o estado guardado precisa ser descartado. NÃO precisa mudar a
// cada deploy.
const STORAGE_VERSION = "login-v2";
const STORAGE_VERSION_KEY = "__storage_version";

export function resetStorageIfOutdated(): void {
  try {
    if (localStorage.getItem(STORAGE_VERSION_KEY) === STORAGE_VERSION) return;

    localStorage.clear();

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .getRegistrations()
        .then((regs) => regs.forEach((r) => r.unregister()))
        .catch(() => {});
    }
    if (typeof caches !== "undefined") {
      caches
        .keys()
        .then((keys) => keys.forEach((k) => caches.delete(k)))
        .catch(() => {});
    }

    localStorage.setItem(STORAGE_VERSION_KEY, STORAGE_VERSION);
  } catch {
    /* localStorage indisponível — ignora */
  }
}

const POLL_INTERVAL_MS = 5 * 60 * 1000;
const RELOADED_FOR_KEY = "__reloaded_for";

async function fetchBuildVersion(): Promise<string | null> {
  try {
    const res = await fetch(`/version.json?_=${Date.now()}`, { cache: "no-store" });
    if (!res.ok) return null;
    const data = await res.json();
    return data?.version ?? null;
  } catch {
    return null;
  }
}

export async function watchForNewBuild(): Promise<void> {
  const loadedVersion = await fetchBuildVersion();
  if (!loadedVersion) return; // sem version.json (ex.: ambiente local) — não monitora

  const check = async () => {
    const latest = await fetchBuildVersion();
    if (!latest || latest === loadedVersion) return;

    // Trava anti-loop caso o HTML esteja cacheado e o reload não traga o build novo.
    if (sessionStorage.getItem(RELOADED_FOR_KEY) === latest) return;
    sessionStorage.setItem(RELOADED_FOR_KEY, latest);
    window.location.reload();
  };

  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) void check();
  });
  window.addEventListener("focus", () => void check());
  setInterval(() => void check(), POLL_INTERVAL_MS);
}
